export const CREATE_INVOICE_TABS = {
  serviceFees: 'serviceFees',
  tierAndVolumePricing: 'tierAndVolumePricing',
  promotions: 'promotions',
} as const;

export type CreateInvoiceTab = typeof CREATE_INVOICE_TABS[keyof typeof CREATE_INVOICE_TABS];